const setContactTab = (contactData,requestJSON) =>{
    let telephones = [];
    let emails = [];
    let receiveTextNotifications = false;
    let receiveEmailNotifications = false;
    if (contactData !== undefined && contactData !== {} && contactData !== undefined && contactData.length !== 0) {
            
        let mapContactData = [];
        mapContactData.push(...contactData.map(obj => ({...obj})));

        mapContactData.forEach(item => {
            item.diff_type = item.settedContactType !== undefined && item.settedContactType !== null && item.settedContactType.value !== "" ? item.settedContactType.value : ""; delete item.settedContactType;
            item.type = item.settedContactUse !== undefined && item.settedContactUse !== null && item.settedContactUse.value !== "" ? item.settedContactUse.value : ""; delete item.settedContactUse;
            item.number = item.settedNumber !== undefined && item.settedNumber !== "" ? item.settedNumber : ""; delete item.settedNumber;
            item.extension = item.settedExtension !== undefined && item.settedExtension !== "" ? item.settedExtension : ""; delete item.settedExtension;
            // item.isPrimary = item.settedPrimaryContactCheck; delete item.settedPrimaryContactCheck;
            item.notification = item.settedNotificationContactCheck; delete item.settedNotificationContactCheck;
            delete item.id;
        });

        mapContactData.forEach(item => {
            if (item.diff_type !== undefined) {
                item.diff_type === "Phone" ? telephones.push(item) : emails.push(item);
            }
        });

        if (telephones !== "" && telephones.length !== 0) {
            telephones.forEach(item => {
                if (item.extension === undefined || item.extension === "") { delete item.extension }
                if (item.notification === true) { receiveTextNotifications = true; }
                item.number = item.number.replace(/-|\s/g, "");
                delete item.diff_type; delete item.notification;
            });
            requestJSON = { ...requestJSON, "telephones": telephones };
            requestJSON = { ...requestJSON, "receiveTextNotifications": receiveTextNotifications };
        }

        if (emails !== "" && emails.length !== 0) {
            emails.forEach(item => {
                if (item.extension === undefined || item.extension === "") { delete item.extension }
                if (item.notification === true) { receiveEmailNotifications = true; }
                item.address = item.number !== undefined && item.number !== "" ? item.number :""; delete item.number;
                delete item.diff_type; delete item.notification; 
            });
            requestJSON = { ...requestJSON, "emails": emails };
            requestJSON = { ...requestJSON, "receiveEmailNotifications": receiveEmailNotifications };
        }

    }
    
    return requestJSON;
}

export default setContactTab